import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForAssetFormatComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'name',
    'label',
    'height',
    'width',
    'isCroppingFormat',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      isMainColumn: true,
    },
    {
      property: 'label',
    },
    {
      property: 'height',
    },
    {
      property: 'width',
    },
    {
      property: 'isCroppingFormat',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
